export const BUILD_VERSION = {
  "buildNumber": 120,
  "buildDate": "2026_09_25",
  "version": "00120/2026_09_25",
  "releaseVersion": "v1.0.29"
};